<template>
    <div>
        <Head><title>Expenses</title></Head>
        <h1 class="mb-8 text-3xl font-bold">Expenses List</h1>
        <div class="flex items-center justify-between mb-6">

            <search-filter :show-input="true" v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
                <template #dateFilter>

                    <date-picker v-model="form.date" :range="true" :time-picker="false" :enable-time-picker="false"
                                 input-class-name="dp-custom-input" :multi-calendars="2" :preset-ranges="presetRanges"
                                 auto-apply>
                    </date-picker>

                </template>
            </search-filter>
        </div>


        <div class="container items-center px-4 py-8 m-auto mt-5">
            <div class="flex flex-wrap pb-3 mx-4 md:mx-24 lg:mx-0">

                <summary-card title="Last Week Expenses" :totals=55
                              :percentage_change=6
                              :change_direction=true #cardIcon>
                    <icon name="cart" class="h-6 w-6 group-hover:text-gray-50" viewBox="0 0 20 20"
                          fill="currentColor"></icon>
                </summary-card>

                <summary-card title="Completed/Ongoing Project" :totals=3
                              :percentage_change=11
                              :change_direction=2 #cardIcon>
                    <icon name="cart" class="h-6 w-6 group-hover:text-gray-50" viewBox="0 0 20 20"
                          fill="currentColor"></icon>
                </summary-card>

                <summary-card title="Labour Expenses" :totals=234000
                              :percentage_change=33
                              :change_direction=16 #cardIcon>
                    <icon name="cart" class="h-6 w-6 group-hover:text-gray-50" viewBox="0 0 20 20"
                          fill="currentColor"></icon>
                </summary-card>

                <summary-card title="Material Expenses" :totals=235566
                              :percentage_change=6
                              :change_direction=6 #cardIcon>
                    <icon name="cart" class="h-6 w-6 group-hover:text-gray-50" viewBox="0 0 20 20"
                          fill="currentColor"></icon>
                </summary-card>

            </div>
        </div>

        <Table :inertia="$inertia" :resource="expenses">
            <template #cell(project)="{ item: expense }">
                <a :href="`/projects/details/${expense.project_id}`"
                   class="py-4 px-6 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                    {{ expense.project }}
                </a>
            </template>

            <template #cell(actions)="{ item: expense }">
                <div class="flex items-center">

                    <!-- Edit Button -->
                    <button @click="openUpdateModal(expense)"
                            class="flex space-x-2 items-center px-4 py-2 bg-green-600 hover:bg-amber-600 rounded-full drop-shadow-md mr-2">
                        <svg class="fill-white" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20"
                             height="20"
                             viewBox="0 0 50 50">
                            <path
                                d="M 46.574219 3.425781 C 45.625 2.476563 44.378906 2 43.132813 2 C 41.886719 2 40.640625 2.476563 39.691406 3.425781 C 39.691406 3.425781 39.621094 3.492188 39.53125 3.585938 C 39.523438 3.59375 39.511719 3.597656 39.503906 3.605469 L 4.300781 38.804688 C 4.179688 38.929688 4.089844 39.082031 4.042969 39.253906 L 2.035156 46.742188 C 1.941406 47.085938 2.039063 47.453125 2.292969 47.707031 C 2.484375 47.898438 2.738281 48 3 48 C 3.085938 48 3.171875 47.988281 3.257813 47.964844 L 10.746094 45.957031 C 10.917969 45.910156 11.070313 45.820313 11.195313 45.695313 L 46.394531 10.5 C 46.40625 10.488281 46.410156 10.472656 46.417969 10.460938 C 46.507813 10.371094 46.570313 10.308594 46.570313 10.308594 C 48.476563 8.40625 48.476563 5.324219 46.574219 3.425781 Z M 45.160156 4.839844 C 46.277344 5.957031 46.277344 7.777344 45.160156 8.894531 C 44.828125 9.222656 44.546875 9.507813 44.304688 9.75 L 40.25 5.695313 C 40.710938 5.234375 41.105469 4.839844 41.105469 4.839844 C 41.644531 4.296875 42.367188 4 43.132813 4 C 43.898438 4 44.617188 4.300781 45.160156 4.839844 Z M 5.605469 41.152344 L 8.847656 44.394531 L 4.414063 45.585938 Z">
                            </path>
                        </svg>
                        <span class="text-white text-md">Edit</span>
                    </button>

                    <!-- Delete button -->
                    <button
                        @click="openDeleteModal(expense.id)"
                        class="flex space-x-2 items-center px-3 py-2 bg-red-500 hover:bg-rose-800 rounded-md drop-shadow-md">
                        <svg class="fill-white" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20"
                             height="20"
                             viewBox="0 0 24 24">
                            <path
                                d="M 10 2 L 9 3 L 3 3 L 3 5 L 21 5 L 21 3 L 15 3 L 14 2 L 10 2 z M 4.3652344 7 L 5.8925781 20.263672 C 6.0245781 21.253672 6.877 22 7.875 22 L 16.123047 22 C 17.121047 22 17.974422 21.254859 18.107422 20.255859 L 19.634766 7 L 4.3652344 7 z">
                            </path>
                        </svg>
                        <span class="text-white">Delete</span>
                    </button>
                </div>
            </template>
        </Table>

    </div>


    <!--edit product  -->
    <DialogModal :show="showUpdateModal">
        <template #title>
            <div class="flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700">
                <h3 class="text-xl font-semibold dark:text-white">
                    Update Expense
                </h3>
                <button type="button"
                        @click="closeUpdateModal"
                        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white"
                        data-modal-toggle="add-user-modal">
                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd"
                              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                              clip-rule="evenodd"></path>
                    </svg>
                </button>
            </div>
        </template>
        <!-- Modal body -->

        <template #content>
            <input type="hidden" v-model="editForm.id">
            <div class="mb-6">
                <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Expense
                    Name</label>
                <input type="text" v-model="editForm.name"
                       class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
            </div>

            <div class="mb-6">
                <div>
                    <label for="role"
                           class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"> Category</label>
                    <select
                        class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                        v-model="editForm.category_id" required
                    >
                        <option v-for="cat in categories"
                                :key="cat.id"
                                :value="cat.id">
                            {{ cat.name }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="mb-6">
                <div>
                    <label for="role"
                           class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"> Phase</label>
                    <select
                        class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                        v-model="editForm.phase_id" required
                    >
                        <option v-for="cat in phases"
                                :key="cat.id"
                                :value="cat.id">
                            {{ cat.name }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="mb-6">
                <label for="price" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Unit
                    Price</label>
                <input type="text" v-model="editForm.unit_cost"
                       class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                       placeholder="Enter Unit cost eg 10" required>
            </div>

            <div class="mb-6">
                <label for="price" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Quantity
                </label>
                <input type="text" v-model="editForm.quantity"
                       class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                       placeholder="Enter Quantity eg 10" required>
            </div>
            <div class="mb-6">
                <label for="price" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    Total Amount</label>
                <input type="text" v-model="editForm.total_amount"
                       class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                       required>
            </div>

            <div class="mb-6">
                <label for="price" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Amount
                    Paid</label>
                <input type="text" v-model="editForm.amount_paid"
                       class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                       required>
            </div>

            <div class="mb-6">
                <label for="email"
                       class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Vendor</label>
                <input type="text" v-model="editForm.vendor"
                       class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                       placeholder="Enter Expense vendor Name eg Test Vendors">
            </div>

            <div class="mb-6">
                <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Description
                </label>
                <textarea type="text" v-model="editForm.description"
                          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          placeholder="Enter Description">

                </textarea>

                <div class="mb-6">
                    <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Project
                    </label>
                    <input type="text" v-model="editForm.project"
                           class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                           placeholder="Expense Project" readonly>
                </div>
            </div>

        </template>


        <!-- Modal footer -->
        <template #footer>
            <div class="items-center p-2 border-t border-gray-200 rounded-b dark:border-gray-700">
                <PrimaryButton
                    @click="updateExpense">Update Expense
                </PrimaryButton>
            </div>
        </template>
    </DialogModal>

    <!--delete expense modal    -->
    <DialogModal :show="showDeleteModal">
        <!-- Modal content -->
        <template #title>
            <div class="flex items-start justify-between p-5 border-b rounded-t dark:border-gray-700">
                <h3 class="text-xl font-semibold dark:text-white">
                    Delete Expense
                </h3>
                <button type="button"
                        @click="closeDeleteModal"
                        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-700 dark:hover:text-white"
                        data-modal-toggle="add-user-modal">
                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd"
                              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                              clip-rule="evenodd"></path>
                    </svg>
                </button>
            </div>
        </template>

        <!-- Modal body -->

        <template #content>
            <input type="hidden" v-model="deleteForm.id">
            <div class="p-6 pt-0 text-center">
                <svg class="w-16 h-16 mx-auto text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                     xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
                <h3 class="mt-5 mb-6 text-lg text-gray-500 dark:text-gray-400">Are you sure you want to delete this
                    Expense?</h3>
                <button
                    @click="deleteExpense"
                    class="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-base inline-flex items-center px-3 py-2.5 text-center mr-2 dark:focus:ring-red-800">
                    Yes, I'm sure
                </button>
                <button
                    @click="closeDeleteModal"
                    class="text-gray-900 bg-white hover:bg-gray-100 focus:ring-4 focus:ring-primary-300 border border-gray-200 font-medium inline-flex items-center rounded-lg text-base px-3 py-2.5 text-center dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-gray-700"
                    data-modal-toggle="delete-user-modal">
                    No, cancel
                </button>
            </div>
        </template>

        <!-- Modal footer -->
        <template #footer>

        </template>

    </DialogModal>


</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import {Table} from "@protonemedia/inertiajs-tables-laravel-query-builder";
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from "@/Shared/Pagination.vue";
import SummaryCard from "@/Shared/SummaryCard";
import {sum} from "lodash/math";
import {ref} from "vue";
import {
    endOfMonth,
    endOfYear,
    endOfYesterday,
    startOfMonth,
    startOfYear,
    startOfYesterday,
    subDays,
    subMonths, subYears
} from "date-fns";
import SelectInput from "@/Shared/SelectInput.vue";
import Modal from "@/Shared/Modal.vue";
import DialogModal from "@/Shared/DialogModal.vue";
import PrimaryButton from "@/Shared/PrimaryButton.vue";


export default {
    components: {
        PrimaryButton,
        DialogModal,
        Modal,
        SelectInput,
        Pagination,
        Head,
        Icon,
        Link,
        SearchFilter,
        SummaryCard,
        Table
    },
    layout: Layout,
    props: {
        filters: Object,
        expenses: Object,
        summary: Object,
        projects: Object,
        categories: Object,
        phases: Object,
    },

    data() {
        return {
            form: {
                search: this.filters.search,
                date: this.filters.date,
            },
            deleteForm: {
                id: ''
            },
            editForm: {
                id: '',
                name: '',
                category_id: '',
                vendor: '',
                phase: '',
                material: '',
                unit_cost: '',
                total_amount: '',
                amount_paid: '',
                project: '',
                quantity: '',
                description: '',
            },
            presetRanges: ref([
                {label: 'Today', range: [new Date(), new Date()]},
                {label: 'Yesterday', range: [startOfYesterday(), endOfYesterday()]},
                {label: 'Last 3 Days', range: [subDays(new Date(), 2), new Date()]},
                {label: 'Last 7 Days', range: [subDays(new Date(), 6), new Date()]},
                {label: 'This month', range: [startOfMonth(new Date()), new Date()]},
                {
                    label: 'Last month',
                    range: [startOfMonth(subMonths(new Date(), 1)), endOfMonth(subMonths(new Date(), 1))],
                },
                {
                    label: 'Last 3 months',
                    range: [startOfMonth(subMonths(new Date(), 3)), new Date()],
                },
                {
                    label: 'Last 6 months',
                    range: [startOfMonth(subMonths(new Date(), 6)), new Date()],
                },
                {label: 'This year', range: [startOfYear(new Date()), new Date()]},
                {
                    label: 'Last year',
                    range: [startOfYear(subYears(new Date(), 1)), endOfYear(subYears(new Date(), 1))]
                },
                {
                    label: 'All Times',
                    range: [startOfYear(subYears(new Date(), 1)), new Date()]
                },
            ]),
            showUpdateModal: false,

            showDeleteModal: false,
        }


    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get('/expenses', pickBy(this.form), {preserveState: true})
            }, 150),
        },
    },
    methods: {
        sum,
        reset() {
            this.form = mapValues(this.form, () => null)
        },
        openUpdateModal(expense) {
            console.log(expense)
            this.editForm.id = expense.id;
            this.editForm.name = expense.name;
            this.editForm.category_id = expense.category_id;
            this.editForm.vendor = expense.vendor;
            this.editForm.phase_id = expense.phase_id;
            this.editForm.quantity = expense.quantity;
            this.editForm.material = expense.material_category;
            this.editForm.unit_cost = expense.unit_cost;
            this.editForm.total_amount = expense.total_amount;
            this.editForm.amount_paid = expense.amount_paid;
            this.editForm.project = expense.project;
            this.editForm.description = expense.description;
            this.showUpdateModal = true;
        },

        openDeleteModal(id) {
            this.deleteForm.id = id
            this.showDeleteModal = true;
        },
        closeUpdateModal() {
            this.showUpdateModal = false;
        },

        closeDeleteModal() {
            this.showDeleteModal = false;
        },
        deleteExpense() {
            let id = this.deleteForm.id;
            this.$inertia.post(`/expenses/delete/${id}`, pickBy(this.deleteForm), {preserveState: true});
            this.closeDeleteModal();
        },
        updateExpense() {
            this.$inertia.post(`/expenses/update`, pickBy(this.editForm), {preserveState: true});
            this.closeUpdateModal();
        }
    },

}
</script>
